module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/facebook-17599b61f1ca15bec8a97893f122b0e6.svg";